var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx } from "react/jsx-runtime";
import { css } from "@/styled-system/css";
import PropTypes from "prop-types";
import { Component } from "react";
import Chart from "./Chart/Chart.esm.js";
import DataSeries from "./DataSeries.esm.js";
const chartFontStyles = css({
  fontFamily: "ui"
});
class DonutChart extends Component {
  render() {
    const {
      cx,
      cy,
      width,
      height,
      data,
      title,
      centerText,
      centerValue,
      valueFormatter,
      colors,
      radius,
      hideLabels,
      smallCenterLabel,
      innerRadius
    } = this.props;
    const transform = `translate(${cx || width / 2},${cy || height / 2})`;
    const values = data.map((item) => item.value);
    const labels = data.map((item) => item.label);
    return /* @__PURE__ */ jsx(Chart, { className: chartFontStyles, width, height, title, children: /* @__PURE__ */ jsx(DataSeries, { centerText, centerValue, valueFormatter, labels, colors, transform, data: values, width, height, radius, hideLabels, smallCenterLabel, innerRadius }) });
  }
}
__publicField(DonutChart, "propTypes", {
  data: PropTypes.array,
  colors: PropTypes.func,
  cx: PropTypes.number,
  cy: PropTypes.number,
  radius: PropTypes.number,
  title: PropTypes.string,
  hideLabels: PropTypes.bool,
  smallCenterLabel: PropTypes.bool,
  innerRadius: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
  centerText: PropTypes.string,
  centerValue: PropTypes.number,
  valueFormatter: PropTypes.func
});
__publicField(DonutChart, "defaultProps", {
  title: ""
});
export {
  DonutChart as default
};
